"use client";

import { c as _c } from "react/compiler-runtime";
import { useUpsell } from "./useUpsell";

/**
 * This is an empty component for controlling Upsell
 * Just needs to exist in the page to spy on the cart
 * and ensure when its upsell time to shine:
 * IT WILL SHINE SO BRIGHT YOU WILL REGRED NOT HAVING SUNGLASSES!
 *
 * @param channel: the current channel slug
 * @param market: the market (region) this exists (only Earth locations now)
 * @returns null: all good things, are invisible and not within grasp
 */
export const UpsellController = t0 => {
  const $ = _c(3);
  const {
    channel,
    market
  } = t0;
  let t1;
  if ($[0] !== channel || $[1] !== market) {
    t1 = {
      channel,
      market
    };
    $[0] = channel;
    $[1] = market;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  useUpsell(t1);
  return null;
};